import { api } from 'api';
import { checkMaintenance } from 'helpers/maintenance';
import { delay, isEmpty } from 'lodash';
import { ROUNDING_DELAY } from '../const';
import useCalculatorRoundingStore from './useCalculatorRoundingStore';

const useCalculatorRoundingPublicAPI = () => {
  const {
    isSendAmountRounding,
    isGetAmountRounding,
    isCalculatorRounding,
    setSendAmountRounding,
    setGetAmountRounding,
    resetCalculatorRounding,
  } = useCalculatorRoundingStore();

  const remitRoundingRequest = async (remitPayload) => {
    const responseDefault = {
      data: {
        ...remitPayload,
        sendingAmount: 0,
        receivingAmount: 0,
      },
    };

    const { sendingAmount, receivingAmount } = remitPayload || {};
    if (!sendingAmount && !receivingAmount) return responseDefault;

    try {
      console.log(
        `⭐ useCalculatorRoundingPublicAPI 👉 remitRoundingRequest ➡️ remitPayload ↩`,
        remitPayload,
      );
      let { data } = await api.remitRoundingPublic(remitPayload);
      console.log(
        `⭐ useCalculatorRoundingPublicAPI 👉 remitRoundingRequest ➡️ data ↩`,
        data,
      );

      if (!isEmpty(data)) {
        return { data };
      }
      return responseDefault;
    } catch (error) {
      checkMaintenance(error);
      console.error(
        `🔥 useCalculatorRoundingPublicAPI ❌ remitRoundingRequest ➡️ ERROR ↩`,
        error?.message,
      );
      return null;
    } finally {
      delay(resetCalculatorRounding, ROUNDING_DELAY + 100);
    }
  };

  return {
    remitRoundingRequest,
  };
};

export default useCalculatorRoundingPublicAPI;
